/* unplugin-vue-components disabled */import { render } from "./blankLayout.vue?vue&type=template&id=0a70fbe0"
const script = {}

import exportComponent from "/drone/src/node_modules/.pnpm/vue-loader@16.8.3_2s7cwfl64decoaat2pz2tykl6i/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__